
import { RouterLink } from 'vue-router';
import { defineComponent, ref } from 'vue';
import { logout } from '@/helpers/auth';

export default defineComponent({
  components: {
    RouterLink
  },

  setup() {
    const activeItem = ref('');

    const setActiveItem = (item: string) => {
      activeItem.value = item;
    };

    return {
      activeItem,
      setActiveItem,
      logout
    };
  }
});
